import { useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useIntl, defineMessages } from 'react-intl'
import first from 'lodash/first'
import { Box, Button } from '@homebotapp/hb-react-component-catalog'
import history from '../../../../history'
import { openLoans } from '../../../../actions/homeowner'
import { editBalance } from '../../../../actions/loan'
import { PaidExtra } from './PaidExtra'
import OverlayPanel from '../../Routing/OverlayPanel'
import { LearnMore } from './LearnMore'
import { OVERLAY_HELPERS } from '../../../../constants/navigation'
import { selectCurrentCELs, selectPrincipalDiff } from '../../../../store/selectors/home/loans'
import { HOMEOWNER_DIGEST_INTEREST_MODULE } from '../../../../constants/tracking/trackingEventLocations/homeownerDigestTrackingEventLocation'

const MSG = defineMessages({
  learnMore: {
    id: 'Homeowner.interest.info.toggle',
    defaultMessage: 'Learn more'
  },
  editLoan: {
    id: 'Homeowner.interest.info.button',
    defaultMessage: 'Already paid extra?'
  }
})

interface InfoProps {
  withCurrentHomeData: boolean
}

export const Info = ({ withCurrentHomeData }: InfoProps) => {
  const dispatch = useDispatch()
  const intl = useIntl()

  const learnMoreRef = useRef(null)
  const loans = useSelector(selectCurrentCELs)
  const principalDiff = useSelector(selectPrincipalDiff)

  const handleLearnMoreClick = () => {
    history.push(OVERLAY_HELPERS.principalPaymentLearnMore.buildPath())
  }

  const handleOnClick = () => {
    dispatch(openLoans())

    if (loans.length === 1) {
      dispatch(editBalance(first(loans)))
    }
  }

  if (!withCurrentHomeData) {
    return null
  }

  return (
    <>
      {principalDiff > 0 && <PaidExtra onClick={handleOnClick} principalDiff={principalDiff} />}
      {principalDiff <= 0 && (
        <Box
          display='flex'
          flexDirection='row'
          alignItems='center'
          justifyContent='center'
          data-qa='paid-extra-button-group'
        >
          <Button
            data-qa='learn-more-button'
            tracking={{
              guid: '6s77n0oEataOEU5W31xeFe',
              ui_context: HOMEOWNER_DIGEST_INTEREST_MODULE,
              descriptor: MSG.learnMore.defaultMessage
            }}
            me='4'
            onClick={handleLearnMoreClick}
          >
            {intl.formatMessage(MSG.learnMore)}
          </Button>
          <Button
            data-qa='already-paid-extra-button'
            tracking={{
              guid: '6bYvCUNrEvf9AA6YXrOAVb',
              ui_context: HOMEOWNER_DIGEST_INTEREST_MODULE,
              descriptor: MSG.editLoan.defaultMessage
            }}
            onClick={handleOnClick}
          >
            {intl.formatMessage(MSG.editLoan)}
          </Button>
        </Box>
      )}

      <OverlayPanel
        ref={learnMoreRef}
        back={OVERLAY_HELPERS.principalPaymentLearnMore.getOrigin()}
        path={OVERLAY_HELPERS.principalPaymentLearnMore.buildPath()}
        title={OVERLAY_HELPERS.getTitle('principalPayment', intl)}
        render={() => <LearnMore withCurrentHomeData={withCurrentHomeData} />}
      />
    </>
  )
}
